import { getConsentFieldNames } from "@client/content/lib/consent";
import { type Consent, type ModuleApiInfo } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { type FormHandles } from "@client/controls/Form/component";
import withIsVisibleHOC, { type WithIsVisibleHOCProps } from "@client/hocs/withIsVisible";
import { type GenericMap } from "@client/types";
import DynamicForm from "@common/controls/Form/DynamicForm/component";
import { type DynamicForms } from "@common/controls/Form/DynamicForm/types";
import { pick } from "lodash";
import * as React from "react";
import { withOnSubmit } from "../../hooks";

export type MapProps = RootContainerProps &
  WithIsVisibleHOCProps & {
    apiInfo: ModuleApiInfo;
    consent: Consent | undefined;
  };
export interface ActionProps {
  onChange: (consent: GenericMap<any>) => void;
}
export type Props = ActionProps & MapProps;

const getData = (fields: DynamicForms.Field[]): GenericMap<any> =>
  fields.reduce((res, x) => ({ ...res, [x.name]: x.value }), {});

export default withIsVisibleHOC((props: Props) => {
  const mapOutput = React.useCallback(
    (data: any) => {
      const consentFieldNames = getConsentFieldNames(props.consent!.fields);

      return { consent: pick(data, consentFieldNames) };
    },
    [props.consent]
  );

  const ref = withOnSubmit<FormHandles>(mapOutput);
  const [data, setData] = React.useState<GenericMap<any>>(getData(props.consent!.fields));

  React.useEffect(() => setData(getData(props.consent!.fields)), [props.consent!.fields]);

  const onChange = React.useCallback(
    (name: string, value: any) => {
      if (name in data) {
        setData({ ...data, [name]: value });

        props.onChange({ ...data, [name]: value });
      }
    },
    [data, setData, props.onChange]
  );
  return (
    <div className="consent">
      <h4>{props.consent!.title}</h4>

      <DynamicForm ref={ref as any} fields={props.consent!.fields} onChange={onChange} />
    </div>
  );
});
